module.exports = __webpack_public_path__ + "static/willBaxterCrop-48bc798623cf81df0410ba8b53dd8056.jpg";